
    import styled from 'styled-components';
    import * as Copy from 'styles/components/copy';

    export const Content = styled.div`
        display: flex;
        position: relative;
        font-family: CNN Condensed;

        flex-direction: column;
        justify-content: center;
        align-items: center;

        width: 100%;
        margin: 0 auto;
        
        flex: 1 0 auto;

    `;

    export const Title = styled(Copy.ParagraphElement)`
        display: flex;
        font-weight: 200;
        font-size: 25px;
        text-align: center;
        
        max-width: 700px;
        letter-spacing: 1.15px;
        
        margin: 0 0;
        padding: 0;

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 35px;
            letter-spacing: 2.52px;
        }
    `;
    
    export const Logo = styled.img`
        pointer-events: none;
        object-fit: contain;
        object-position: center;
        width: auto;
        height: 85px;
        max-width: 100%;
        margin: 30px 0 30px;
        padding: 0 20px;

        ${({theme}) => theme.breakpoints['md']}
        {
            margin: 50px 0;
            height: 125px;
        }
    `;

    export const Description = styled(Copy.SpanElement)`
        font-size: 16px;
        font-weight: 200;
        letter-spacing: 0.97px;
        text-align: center;

        color: #437079;
        max-width: 500px;

        strong
        {
            white-space: nowrap;
        }
    `;

    export const Form = styled.form`
        display: flex;
        flex-direction: column;
        align-items: center;
        
        margin: 30px 0;

        ${({theme}) => theme.breakpoints['md']}
        {
            margin: 50px 0 30px;
        }
    `;

    export const EmailInput = styled.input`
        font-family: CNN Condensed;
        border-radius: 20px;
        outline: none;
        border: none;
        
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0.5px;

        padding: 18px 20px;
        margin-bottom: 12px;

        width: 300px;
        height: 45px;

        ::placeholder
        {
            font-weight: 300;
            text-align: center;
            text-transform: uppercase;
            color: #437079;
        }

        .error &
        {
            border: 1px solid ${({theme}) => theme['cnn-red']};

            ::placeholder
            {
                color: ${({theme}) => theme['cnn-red']};
            }
        }
    `;

    export const Error = styled(Copy.SpanElement)`
        color: ${({theme}) => theme['cnn-red']};
        font-size: 16px;
        font-weight: 200;
        letter-spacing: 0.97px;
        text-align: center;
        max-width: 500px;
    `;

    export const Submit = styled.input`
        user-select: none;
        cursor: pointer;

        display: flex;
        position: relative;
        background: none;
        border: none;

        font-size: 16px;
        font-weight: 500;
        color: #437079;

        text-transform: lowercase;
        text-decoration: underline;

        margin-top: 12px;

        flex-direction: row;
        justify-content: center;
        align-items: center;
    `;

    export const Skip = styled(Copy.Anchor)`
        font-size: 16px;
        font-weight: 300;
        color: #437079;
    `;
    